<template>
    <div class="w-full space-y-3">
        <Head title="Management Fees"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Management Fee Invoices <span class="text-sm text-gray-500">for {{ organisation.name }}</span></h1>
        </div>
        <div class="w-full flex gap-3 justify-between">
            <div class="flex gap-3 w-full">
                <span @click="emitter.emit('openManagementFeeInvoiceSlideout', organisation)"
                    class="cursor-pointer inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Add New Management Fee Invoice
                </span>
            </div>
        </div>
    </div>
    <div class="mt-5 bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <InvoiceList :invoices="organisation.management_fee_invoices" :project="project" :invoice_type="'Management Fee'" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <CreateManagementFeeInvoice />
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head} from "@inertiajs/vue3";
import {CreditCardIcon, NewspaperIcon} from "@heroicons/vue/outline";
import CreateManagementFeeInvoice from "@/Components/SlideOuts/CreateManagementFeeInvoice.vue";
import {emitter} from "@/eventHub";
import InvoiceList from "@/Components/InvoiceList.vue";

export default {
    layout: Authenticated,
    components: {
        Head,
        Link,
        CreditCardIcon,
        NewspaperIcon,
        CreateManagementFeeInvoice,
        InvoiceList
    },
    props: {
        organisation: Object
    },
    data () {
        return {
            emitter: emitter,
        }
    }
}
</script>
